var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wifi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9999 15.7651C11.6526 15.7651 11.326 15.9003 11.0806 16.1459C10.8349 16.3916 10.6997 16.718 10.6997 17.0654C10.6997 17.4127 10.8349 17.7391 11.0806 17.9847C11.326 18.2303 11.6524 18.3656 11.9999 18.3656C12.3475 18.3656 12.6739 18.2305 12.9193 17.9849C13.165 17.7391 13.3004 17.4127 13.3004 17.0654C13.3004 16.718 13.165 16.3916 12.9193 16.146C12.6739 15.9003 12.3473 15.7651 11.9999 15.7651ZM12.2857 17.3511C12.1329 17.5036 11.8669 17.5036 11.7142 17.3511C11.6379 17.2747 11.5959 17.1733 11.5959 17.0654C11.5959 16.9575 11.6379 16.856 11.7142 16.7797C11.7906 16.7035 11.8919 16.6614 11.9999 16.6614C12.108 16.6614 12.2093 16.7033 12.2857 16.7797C12.362 16.856 12.4041 16.9575 12.4041 17.0654C12.4041 17.1733 12.362 17.2747 12.2857 17.3511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.26183 13.7989C8.08671 13.9738 8.08671 14.2575 8.26183 14.4327C8.34913 14.5201 8.46402 14.5639 8.57874 14.5639C8.69345 14.5639 8.80799 14.5201 8.89564 14.4327C10.6074 12.7214 13.3923 12.7214 15.1038 14.4327C15.2789 14.6076 15.5624 14.6076 15.7374 14.4327C15.9125 14.2577 15.9125 13.974 15.7374 13.7989C13.6764 11.7383 10.3231 11.7383 8.26183 13.7989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.80834 11.3447C5.63322 11.5197 5.63322 11.8034 5.80834 11.9783C5.98346 12.1535 6.26703 12.1535 6.44197 11.9783C9.50668 8.91382 14.4932 8.91382 17.558 11.9783C17.6454 12.0658 17.7601 12.1096 17.8749 12.1096C17.9896 12.1096 18.1041 12.0658 18.1918 11.9783C18.3669 11.8034 18.3669 11.5197 18.1918 11.3447C14.7775 7.93067 9.2224 7.93067 5.80834 11.3447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.8688 8.66753C15.9786 3.77758 8.02147 3.7774 3.13134 8.66753C2.95622 8.84247 2.95622 9.12621 3.13134 9.30116C3.30646 9.47628 3.59003 9.47628 3.76497 9.30116C8.30575 4.76037 15.6944 4.76055 20.2351 9.30116C20.3226 9.38863 20.4373 9.43236 20.552 9.43236C20.6668 9.43236 20.7813 9.38863 20.8689 9.30116C21.0437 9.12621 21.0437 8.84247 20.8688 8.66753Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/Wifi.bc8143165b25351175dc54a9204911c8.svg";
export { ForwardRef as ReactComponent };